/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./toast.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../../../../node_modules/primeng/toast/primeng-toast.ngfactory";
import * as i3 from "primeng/toast";
import * as i4 from "primeng/api";
import * as i5 from "./toast.component";
var styles_ToastComponent = [i0.styles];
var RenderType_ToastComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ToastComponent, data: {} });
export { RenderType_ToastComponent as RenderType_ToastComponent };
export function View_ToastComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "p-toast", [], null, [[null, "onClose"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("onClose" === en)) {
        var pd_0 = (_co.onClose.emit($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, i2.View_Toast_0, i2.RenderType_Toast)), i1.ɵdid(1, 1294336, null, 1, i3.Toast, [i4.MessageService, i1.ChangeDetectorRef], { key: [0, "key"] }, { onClose: "onClose" }), i1.ɵqud(603979776, 1, { templates: 1 })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.key; _ck(_v, 1, 0, currVal_0); }, null); }
export function View_ToastComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-toast", [], null, null, null, View_ToastComponent_0, RenderType_ToastComponent)), i1.ɵdid(1, 49152, null, 0, i5.ToastComponent, [], null, null)], null, null); }
var ToastComponentNgFactory = i1.ɵccf("app-toast", i5.ToastComponent, View_ToastComponent_Host_0, { key: "key" }, { onClose: "onClose" }, []);
export { ToastComponentNgFactory as ToastComponentNgFactory };
